import { FaCalendarWeek } from "react-icons/fa";
import ReactPixel from 'react-facebook-pixel';

// Small component that asks user to pick a date from provided API dates
// Props: onSelect(label, isoDate), dates: array of strings in "DD-MM-YYYY HH:MM" or "DD-MM-YYYY"
const parseApiDate = (s) => {
  if (!s) return null;
  // normalize whitespace and remove invisible chars
  const cleaned = String(s)
    .replace(/\u200B|\uFEFF/g, "")
    .replace(/\u00A0/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const [datePart, timePart] = cleaned.split(" ");
  const [dd, mm, yyyy] = (datePart || "").split("-").map((p) => parseInt(p, 10));
  if ([dd, mm, yyyy].some((n) => isNaN(n))) return null;
  const [hh = 0, min = 0] = (timePart || "").split(":").map((p) => parseInt(p, 10));
  return new Date(yyyy, mm - 1, dd, isNaN(hh) ? 0 : hh, isNaN(min) ? 0 : min);
};

const formatDateLabel = (d) => {
  if (!d) return "";
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};

const DayQuestion = ({ onSelect, dates = [], showHost }) => {
  // Only render API-provided dates; if none, render nothing
  const items = (dates && dates.length > 0)
    ? dates
      .map((s) => ({ raw: s, date: parseApiDate(s) }))
      .filter((x) => x.date)
    : [];

  // Show up to 4 upcoming dates (current or future) in chronological order.
  // We consider a date "upcoming" only if its time is >= now (so today's past times are excluded).
  const now = new Date();
  const future = items
    .filter((x) => x.date && x.date >= now)
    .sort((a, b) => a.date - b.date);

  // Take the first 2 upcoming slots (always show a dual selection). If only one is available, show one.
  // const slots = future.slice(0, 2);
  const slots = future;

  // If API dates provided we return label as the raw string, otherwise label keys
  return (
    <div className="mb-6">
      <label className="block text-lg font-medium mb-12 -mt-10 text-black">
        {/* Which date do you prefer? */}
        {
          ReactPixel.track("Date", {
            model: 'NO_HOST'
          })
        }
      </label>
      {items.length === 0 ? (
        <div className="text-gray-500 flex flex-col items-center">
          <img src="https://img.icons8.com/?size=96&id=0Pd8BYFOcvVH&format=png" alt="No Dates" className="w-32 h-32 mx-auto mb-4" />
          No slots open at the moment — hang tight, more tables coming your way!
        </div>
      ) : (

        showHost ? (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div
                onClick={() => onSelect('host_tables', new Date().toISOString())}
                className="px-4 py-6 cursor-pointer rounded-xl border-[#f7c900] flex border-4 text-gray-700 hover:shadow-md bg-gray-50"
              >
                <div className="font-semibold sm:text-xl">
                  Host Tables
                </div>
              </div>
            </div>
          </>
        ) :
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {slots.map((it, idx) => {
              const dateObj = it.date || it;
              const dayName = dateObj ? dateObj.toLocaleDateString(undefined, { weekday: 'long' }) : '';
              return (
                <div
                  key={idx}
                  onClick={() => onSelect(it.raw || (it.label || `date_${idx}`), (dateObj).toISOString())}
                  className="px-4 py-6 cursor-pointer justify-between rounded-xl border-[#f7c900] flex border-4 text-center text-gray-700 hover:shadow-md bg-gray-50"
                >
                  <div className="font-semibold sm:text-xl">{it.raw ? dayName : (it.label === 'next_saturday' ? 'Next Saturday' : 'Next Sunday')}</div>
                  <div className="text-sm text-gray-500 flex items-center">
                    <FaCalendarWeek className="inline-block w-5 h-5 mr-2 text-gray-400" />
                    {it.raw ? formatDateLabel(dateObj) : formatDateLabel(dateObj)}
                  </div>
                </div>
              );
            })}
          </div>
      )}
    </div>
  );
};

export default DayQuestion;
